import { render } from "./DiagnosisBatteryTest.vue?vue&type=template&id=a1caaab8&scoped=true"
import script from "./DiagnosisBatteryTest.vue?vue&type=script&lang=js"
export * from "./DiagnosisBatteryTest.vue?vue&type=script&lang=js"

import "./DiagnosisBatteryTest.vue?vue&type=style&index=0&id=a1caaab8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a1caaab8"]])

export default __exports__